export const cibHaskell = ["32 32","<path d='M0.011 27.292l7.52-11.292-7.52-11.292h5.645l7.563 11.292-7.563 11.292zM7.531 27.292l7.521-11.292-7.521-11.292h5.688l15.005 22.584h-5.631l-4.713-7.12-4.661 7.12zM25.735 20.697l-2.505-3.765h8.76v3.765zM21.964 15.052l-2.5-3.765h12.515v3.765z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-haskell.js
// module id = null
// module chunks = 